import { createFileRoute } from '@tanstack/react-router'

import { guardStep } from '@/app/route-guards'
import { TextsScreen } from '@/features/steps'

/** Step 2, Texts: originals and translations, Translate. */
export const Route = createFileRoute('/_auth/documents/$docId/texts')({
  beforeLoad: ({ context, params }) => guardStep(context.queryClient, params.docId),
  component: TextsRoute,
})

function TextsRoute() {
  const { docId } = Route.useParams()
  return <TextsScreen docId={docId} />
}
